export default "__VITE_ASSET__I1i7fZ0T__"